import { BaseCurrencyInput, Radio } from "@components";
import styles from "@styles/forms-flow/orders.module.scss";
import { useEffect, useState } from "react";

export const LastConversionForm = ({ node, onChange, onSave }) => {
  const [controllerInputs, setControllerInputs] = useState(getInputType(node));

  const [min, setMin] = useState(node.data.last_conversion?.min || null);
  const [max, setMax] = useState(node.data.last_conversion?.max || null);
  const [exact, setExact] = useState(node.data.last_conversion?.exact || null);

  const getFreshNode = () => {
    const dataValue = {
      ...(node?.data || {}),
      last_conversion: { min, max, exact },
    };

    switch (controllerInputs) {
      case "range":
        dataValue.last_conversion.exact = undefined;
        break;
      case "minimum":
        dataValue.last_conversion.exact = undefined;
        dataValue.last_conversion.max = undefined;
        break;
      case "exact":
        dataValue.last_conversion.min = undefined;
        dataValue.last_conversion.max = undefined;
        break;
    }

    return {
      ...node,
      data: dataValue,
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [min, max, exact]);

  return (
    <>
      <p className={styles.label}>Defina a quantidade de dias sem pedir</p>

      <Radio
        text="Faixa de dias sem pedir"
        family="DaysWithoutConversion"
        className="mb-15"
        value="range"
        checked={controllerInputs}
        onChange={() => setControllerInputs("range")}
      />

      {controllerInputs === "range" && (
        <div className="mb-20 d-flex align-center">
          <BaseCurrencyInput
            className="w-100 mr-15"
            value={min}
            precision={0}
            prefix=""
            suffix=" dias"
            onChange={(v) => setMin(v)}
          />
          <BaseCurrencyInput
            className="w-100"
            value={max}
            precision={0}
            prefix=""
            suffix=" dias"
            onChange={(v) => setMax(v)}
          />
        </div>
      )}

      <Radio
        text="Mínimo de dias sem pedir"
        family="DaysWithoutConversion"
        className="mb-15"
        value="minimum"
        checked={controllerInputs}
        onChange={() => setControllerInputs("minimum")}
      />

      {controllerInputs === "minimum" && (
        <BaseCurrencyInput
          className="mb-20 w-100"
          value={min}
          precision={0}
          prefix=""
          suffix=" dias"
          onChange={(v) => setMin(v)}
        />
      )}

      <Radio
        text="Dias sem pedir exato"
        family="DaysWithoutConversion"
        className="mb-15"
        value="exact"
        checked={controllerInputs}
        onChange={() => setControllerInputs("exact")}
      />

      {controllerInputs === "exact" && (
        <BaseCurrencyInput
          className="mt-20 w-100"
          value={exact}
          precision={0}
          prefix=""
          suffix=" dias"
          onChange={(v) => setExact(v)}
        />
      )}
    </>
  );
};

const getInputType = (node) => {
  const { data } = node || {};
  if (data?.exact !== null && data?.exact !== undefined) {
    return "exact";
  } else if (data?.max !== null && data?.max !== undefined) {
    return "range";
  } else if (data?.min !== null && data?.min !== undefined) {
    return "minimum";
  } else {
    return "range";
  }
};
